(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[94],{

/***/ 3303:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[...slug]",
      function () {
        return __webpack_require__(3667);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function PageTitle(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "text-3xl font-extrabold leading-9 tracking-tight text-gray-900 dark:text-gray-100 sm:text-4xl sm:leading-10 md:text-5xl md:leading-14",
        children: children
    });
}


/***/ }),

/***/ 9829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ TagSEO; },
/* harmony export */   "TQ": function() { return /* binding */ PageSEO; },
/* harmony export */   "Uy": function() { return /* binding */ BlogSEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1576);
/* harmony import */ var _data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3__);




const CommonSEO = (param)=>{
    let { title , description , ogType , ogImage , twImage  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "follow, index"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(router.asPath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().title)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            typeof ogImage === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }, ogImage) : ogImage.map((param)=>/*#__PURE__*/ {
                let { url  } = param;
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: url
                }, url);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().twitter)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: twImage
            })
        ]
    });
};
const PageSEO = (param)=>{
    let { title , description  } = param;
    const ogImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    const twImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
        title: title,
        description: description,
        ogType: "website",
        ogImage: ogImageUrl,
        twImage: twImageUrl
    });
};
const TagSEO = (param)=>{
    let { title , description  } = param;
    const ogImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    const twImageUrl = (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl) + (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
                title: title,
                description: description,
                ogType: "website",
                ogImage: ogImageUrl,
                twImage: twImageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    type: "application/rss+xml",
                    title: "".concat(description, " - RSS feed"),
                    href: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(router.asPath, "/feed.xml")
                })
            })
        ]
    });
};
const BlogSEO = (param)=>{
    let { title , summary , date , lastModified , url , images =[]  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const publishedAt = new Date(date).toISOString();
    const modifiedAt = new Date(lastModified || date).toISOString();
    let imagesArr = images.length === 0 ? [
        (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().socialBanner)
    ] : typeof images === "string" ? [
        images
    ] : images;
    const featuredImages = imagesArr.map((img)=>{
        return {
            "@type": "ImageObject",
            url: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(img)
        };
    });
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Article",
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        headline: title,
        image: featuredImages,
        datePublished: publishedAt,
        dateModified: modifiedAt,
        author: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().author),
        publisher: {
            "@type": "Organization",
            name: (_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().author),
            logo: {
                "@type": "ImageObject",
                url: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteLogo))
            }
        },
        description: summary
    };
    const twImageUrl = featuredImages[0].url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CommonSEO, {
                title: title,
                description: summary,
                ogType: "article",
                ogImage: featuredImages,
                twImage: twImageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    date && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:published_time",
                        content: publishedAt
                    }),
                    lastModified && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "article:modified_time",
                        content: modifiedAt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "".concat((_data_siteMetadata__WEBPACK_IMPORTED_MODULE_3___default().siteUrl)).concat(router.asPath)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(structuredData, null, 2)
                        }
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 2065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_utils_kebabCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(195);



const Tag = (param)=>{
    let { text  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: "/tags/".concat((0,_lib_utils_kebabCase__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(text)),
        className: "mr-3 text-sm font-medium uppercase text-primary-500 hover:text-primary-600 dark:hover:text-primary-400",
        children: text.split(" ").join("-")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tag);


/***/ }),

/***/ 195:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const kebabCase = (str)=>{
    var ref;
    return str && ((ref = str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) === null || ref === void 0 ? void 0 : ref.map((x)=>x.toLowerCase()).join("-"));
};
/* harmony default export */ __webpack_exports__["Z"] = (kebabCase);


/***/ }),

/***/ 3667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/PageTitle.tsx
var PageTitle = __webpack_require__(2866);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/mdx-bundler/client/index.js
var client = __webpack_require__(3194);
// EXTERNAL MODULE: ./components/CustomLink.tsx
var CustomLink = __webpack_require__(7896);
;// CONCATENATED MODULE: ./components/TOCInline.tsx

/**
 * Generates an inline table of contents
 * Exclude titles matching this string (new RegExp('^(' + string + ')$', 'i')).
 * If an array is passed the array gets joined with a pipe (new RegExp('^(' + array.join('|') + ')$', 'i')).
 */ const TOCInline = (param)=>{
    let { toc , indentDepth =3 , fromHeading =1 , toHeading =6 , asDisclosure =false , exclude =""  } = param;
    const re = Array.isArray(exclude) ? new RegExp("^(" + exclude.join("|") + ")$", "i") : new RegExp("^(" + exclude + ")$", "i");
    const filteredToc = toc.filter((heading)=>heading.depth >= fromHeading && heading.depth <= toHeading && !re.test(heading.value));
    const tocList = /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: filteredToc.map((heading)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "".concat(heading.depth >= indentDepth && "ml-6"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: heading.url,
                    children: heading.value
                })
            }, heading.value))
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: asDisclosure ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
            open: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("summary", {
                    className: "pt-2 pb-2 ml-6 text-xl font-bold",
                    children: "Table of Contents"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ml-6",
                    children: tocList
                })
            ]
        }) : tocList
    });
};
/* harmony default export */ var components_TOCInline = (TOCInline);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/Pre.tsx


const Pre = (param)=>{
    let { children  } = param;
    const textInput = (0,react.useRef)(null);
    const [hovered, setHovered] = (0,react.useState)(false);
    const [copied, setCopied] = (0,react.useState)(false);
    const onEnter = ()=>{
        setHovered(true);
    };
    const onExit = ()=>{
        setHovered(false);
        setCopied(false);
    };
    const onCopy = ()=>{
        var ref;
        if ((ref = textInput.current) === null || ref === void 0 ? void 0 : ref.textContent) {
            setCopied(true);
            navigator.clipboard.writeText(textInput.current.textContent);
            setTimeout(()=>{
                setCopied(false);
            }, 2000);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: textInput,
        onMouseEnter: onEnter,
        onMouseLeave: onExit,
        className: "relative",
        children: [
            hovered && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Copy code",
                type: "button",
                className: "absolute right-2 top-2 w-8 h-8 p-1 rounded border-2 bg-gray-700 dark:bg-gray-800 ".concat(copied ? "focus:outline-none focus:border-green-400 border-green-400" : "border-gray-300"),
                onClick: onCopy,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    fill: "none",
                    className: copied ? "text-green-400" : "text-gray-300",
                    children: copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                children: children
            })
        ]
    });
};
/* harmony default export */ var components_Pre = (Pre);

// EXTERNAL MODULE: ./node_modules/mdx-embed/dist/index.js
var dist = __webpack_require__(6222);
// EXTERNAL MODULE: ./components/SectionContainer.tsx
var SectionContainer = __webpack_require__(1536);
// EXTERNAL MODULE: ./components/SEO.tsx
var SEO = __webpack_require__(9829);
// EXTERNAL MODULE: ./components/Tag.tsx
var Tag = __webpack_require__(2065);
// EXTERNAL MODULE: ./data/siteMetadata.js
var siteMetadata = __webpack_require__(1576);
var siteMetadata_default = /*#__PURE__*/__webpack_require__.n(siteMetadata);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./lib/fetcher.ts
var fetcher = __webpack_require__(6965);
;// CONCATENATED MODULE: ./lib/hooks/useViewCounter.tsx



function useViewCounter(slug) {
    const { data  } = (0,swr_dist/* default */.ZP)("/api/view-count/".concat(slug), fetcher/* default */.Z);
    const views = new Number(data === null || data === void 0 ? void 0 : data.total);
    (0,react.useEffect)(()=>{
        const registerView = ()=>fetch("/api/view-count/".concat(slug), {
                method: "POST"
            });
        registerView();
    }, [
        slug
    ]);
    return "".concat(views > 0 ? views.toLocaleString() : "–––", " views");
}

;// CONCATENATED MODULE: ./layouts/PostLayout.tsx









const editUrl = (fileName)=>"".concat((siteMetadata_default()).siteRepo, "/blob/master/data/blog/").concat(fileName);
const discussUrl = (slug)=>"https://mobile.twitter.com/search?q=".concat(encodeURIComponent("".concat((siteMetadata_default()).siteUrl, "/blog/").concat(slug)));
function PostLayout(param) {
    let { children , frontMatter , next , prev  } = param;
    const { slug , fileName , date , title , tags , readingMinutes  } = frontMatter;
    const roundedReadingMinutes = Math.round(readingMinutes);
    const viewCount = useViewCounter(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* BlogSEO */.Uy, {
                ...frontMatter,
                url: "".concat((siteMetadata_default()).siteUrl, "/blog/").concat(frontMatter.slug)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "xl:divide-y xl:divide-gray-200 xl:dark:divide-gray-700",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: "pt-6 xl:pb-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "space-y-1 text-center",
                                children: [
                                    date && /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                                        className: "space-y-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                    className: "sr-only",
                                                    children: "Published on"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                    className: "text-base font-medium leading-6 text-gray-500 dark:text-gray-400",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                        dateTime: date,
                                                        children: new Date(date).toLocaleDateString((siteMetadata_default()).locale, {
                                                            weekday: "long",
                                                            year: "numeric",
                                                            month: "long",
                                                            day: "numeric"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-xs tracking-wide text-gray-500 uppercase dark:text-gray-400",
                                        children: [
                                            roundedReadingMinutes,
                                            " ",
                                            roundedReadingMinutes == 1 ? " minute " : " minutes " + " read - ",
                                            viewCount
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pb-8 divide-y divide-gray-200 xl:divide-y-0 dark:divide-gray-700 xl:grid xl:grid-cols-4 xl:gap-x-6",
                            style: {
                                gridTemplateRows: "auto 1fr"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                    className: "pt-6 pb-10 xl:pt-11 xl:border-b xl:border-gray-200 xl:dark:border-gray-700",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                            className: "sr-only",
                                            children: "Authors"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "flex justify-center space-x-8 xl:block sm:space-x-12 xl:space-x-0 xl:space-y-8",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: "flex items-center space-x-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: (siteMetadata_default()).image,
                                                            alt: "avatar",
                                                            width: 40,
                                                            height: 40,
                                                            className: "rounded-full"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                                                            className: "text-sm font-medium leading-5 whitespace-nowrap",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: "sr-only",
                                                                    children: "Name"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    className: "text-gray-900 dark:text-gray-100",
                                                                    children: (siteMetadata_default()).author
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                                                    className: "sr-only",
                                                                    children: "Twitter"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                                        href: (siteMetadata_default()).twitter,
                                                                        className: "text-primary-500 hover:text-primary-600 dark:hover:text-primary-400",
                                                                        children: siteMetadata_default().twitter.replace("https://twitter.com/", "@")
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "divide-y divide-gray-200 dark:divide-gray-700 xl:pb-0 xl:col-span-3 xl:row-span-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pt-10 pb-8 prose dark:prose-dark max-w-none",
                                            children: children
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "pt-6 pb-6 text-sm text-gray-700 dark:text-gray-300",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                    href: discussUrl(slug),
                                                    rel: "nofollow",
                                                    children: "Discuss on Twitter"
                                                }),
                                                " • ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                    href: editUrl(fileName),
                                                    children: "View on GitHub"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-sm font-medium leading-5 divide-gray-200 xl:divide-y dark:divide-gray-700 xl:col-start-1 xl:row-start-2",
                                            children: [
                                                tags && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "py-4 xl:py-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: "text-xs tracking-wide text-gray-500 uppercase dark:text-gray-400",
                                                            children: "Tags"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "flex flex-wrap",
                                                            children: tags.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                                                                    text: tag
                                                                }, tag))
                                                        })
                                                    ]
                                                }),
                                                (next || prev) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between py-4 xl:block xl:space-y-8 xl:py-8",
                                                    children: [
                                                        prev && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "text-xs tracking-wide text-gray-500 uppercase dark:text-gray-400",
                                                                    children: "Previous Article"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "text-primary-500 hover:text-primary-600 dark:hover:text-primary-400",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                                        href: "/blog/".concat(prev.slug),
                                                                        children: prev.title
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        next && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                    className: "text-xs tracking-wide text-gray-500 uppercase dark:text-gray-400",
                                                                    children: "Next Article"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "text-primary-500 hover:text-primary-600 dark:hover:text-primary-400",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                                        href: "/blog/".concat(next.slug),
                                                                        children: next.title
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pt-4 xl:pt-8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                                href: "/blog",
                                                className: "text-primary-500 hover:text-primary-600 dark:hover:text-primary-400",
                                                children: "← Back"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/MDXComponents.tsx









const MDXComponents = {
    Image: (image_default()),
    // @ts-expect-error
    CodePen: dist/* CodePen */.sp,
    // @ts-expect-error
    Tweet: dist/* Tweet */.tP,
    TOCInline: components_TOCInline,
    // @ts-expect-error
    a: CustomLink/* default */.Z,
    // @ts-expect-error
    pre: components_Pre,
    wrapper: PostLayout
};
const MDXLayoutRenderer = (param)=>{
    let { layout , mdxSource , ...rest } = param;
    const MDXLayout = (0,react.useMemo)(()=>(0,client.getMDXComponent)(mdxSource), [
        mdxSource
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MDXLayout, {
        layout: layout,
        components: MDXComponents,
        ...rest
    });
};

;// CONCATENATED MODULE: ./pages/blog/[...slug].tsx



const DEFAULT_LAYOUT = "PostLayout";
var __N_SSG = true;
function Blog(param) {
    let { post , prev , next  } = param;
    const { mdxSource , toc , frontMatter  } = post;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !frontMatter.draft ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MDXLayoutRenderer, {
            layout: frontMatter.layout || DEFAULT_LAYOUT,
            toc: toc,
            mdxSource: mdxSource,
            frontMatter: frontMatter,
            prev: prev,
            next: next
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mt-24 text-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageTitle/* default */.Z, {
                children: [
                    "Under Construction",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        role: "img",
                        "aria-label": "roadwork sign",
                        children: "\uD83D\uDEA7"
                    })
                ]
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,453,774,888,179], function() { return __webpack_exec__(3303); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);